import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
})
export class LoaderComponent {
    @Input() loading: boolean;
    @Input() fullPage: boolean;
    @Input() text: string;
    @Input() title = 'Chargement';
}
